
import AppPriceRuleEditList from "@/components/price-rules/PriceRuleEditList.vue";
import { Contact } from "@/models/base";
import { ContactPriceRule } from "@/models/base/contact-price-rule";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			toEditRule: null as ContactPriceRule | null
		};
	},
	props: {
		contact: {
			type: Object as ()=>Contact,
			required: true
		}
	},
	computed: {
		newRuleConstructor():()=>ContactPriceRule {
			return ()=>new ContactPriceRule();
		}
	},
	components: {
		AppPriceRuleEditList
	},
	i18nEx: {
		componentPrefix: "components.contacts"
	}
});
